<template>
  <span class="tree-expand" @click="nodeClick(STORE,DATA,NODE)">
    <span class="tree-label" v-if="isnodeEdit">
      <el-input class="edit" size="mini" autofocus="true" maxlength="30" minlength="1" v-model="DATA.label" :ref="'treeInput'+DATA.id" @click.stop.native="nodeEditFocus" @keyup.enter.stop.native="nodeEditPass(STORE,DATA,NODE)">
        <i slot="suffix" typed="sumbit" class="el-input__icon el-icon-circle-check icon-success"></i>
        <i slot="suffix" typed="chanel" class="el-input__icon el-icon-circle-close icon-chanel"></i>
      </el-input>
    </span>
    <span v-show="!isnodeEdit" class="tree-label anti-content" v-html='companyname'>
    </span>
    <span class="anti-content" v-show="!checkboxmode">
      {{DATA.num}}
    </span>
    <span class="tree-btn" v-show="!isnodeEdit && !checkboxmode && headerShowflag&&DATA.isOperator===1">
      <i v-if="checkOperationPermission('city/add')" class="el-icon-plus anti-content" @click.stop="nodeAdd(STORE,DATA,NODE)"></i>
      <i v-if="checkOperationPermission('city/modify')" class="el-icon-edit anti-content" @click.stop="nodeEdit(STORE,DATA,NODE)" v-show="DATA.upOrg != 0 ? true : false"></i>
      <i v-if="checkOperationPermission('city/delete')" class="el-icon-delete anti-content" @click.stop="nodeDel(STORE,DATA,NODE)" v-show="DATA.upOrg != 0 ? true : false"></i>
    </span>
  </span>
</template>

<script>
export default {
  name: 'treeExpand',
  props: [
    'NODE',
    'DATA',
    'STORE',
    'maxexpandId',
    'checkboxmode',
    'headerShowflag',
    'clicknode',
    'NodeId',
    'props'
  ],
  data () {
    return {
      companyname: '',
      isnodeEdit: false,
      currentNodeId: this.DATA.id
    }
  },

  mounted () {
    this.companyname = this.$props.DATA[this.props.label]
    this.DATA.label = this.DATA.name
    if (this.$props.DATA.add) {
      this.isnodeEdit = true
      this.DATA.label = this.$props.DATA[this.props.label]
      let idInfo = {
        id: this.$props.DATA.id,
        upOrg: this.$props.DATA.upOrg
      }
      this.$store.commit('setCurrnetNodeInfo', idInfo)
    }
  },

  computed: {
    isnodeClicked () {
      return this.currentNodeId === this.$store.getters.getCurrentNodeId
    }
  },
  watch: {
    isnodeClicked (val) {
      if (!this.isnodeClicked && this.isnodeEdit && !this.DATA.add) {
        this.isnodeEdit = false
      }
      if (!this.isnodeClicked && this.isnodeEdit && this.DATA.add) {
        this.delNode()
      }
    }
  },
  methods: {
    nodeAdd (s, d, n) {
      // 新增
      this.$emit('nodeAdd', s, d, n)
    },
    nodeEdit (s, d, n) {
      // 编辑
      let idInfo = {
        id: d.id,
        upOrg: d.upOrg
      }
      this.$store.commit('setCurrnetNodeInfo', idInfo)
      this.isnodeEdit = true
      this.$nextTick(() => {
        this.$refs['treeInput' + d.id].$refs.input.focus()
      })
      this.$emit('nodeEdit', s, d, n)
    },

    // 删除
    nodeDel (s, d, n) {
      this.$emit('nodeDel', s, d, n)
    },

    // 编辑完成
    nodeEditPass (s, d, n) {
      // this.isnodeClicked = true;
      this.$store.commit('setCurrnetNodeInfo', {
        id: '',
        upOrg: ''
      })
      this.companyname = this.DATA.label
      if (this.$props.DATA.add) {
        this.$props.DATA.add = false
      }
      this.$emit('nodeEditPass', s, d, n)
    },
    chanelNode (s, d, n) {
      this.isnodeEdit = false
    },
    nodeClick (s, d, n) {
      if (this.clicknode === true) {
        if (d.nodes.length > 0) {
          return false
        } else {
          this.isnodeEdit = false
          this.$emit('nodeClick', s, d, n)
          let idInfo = {
            id: d.id,
            upOrg: d.upOrg
          }
          this.$store.commit('setCurrnetNodeInfo', idInfo)
        }
      } else {
        this.isnodeEdit = false
        this.$emit('nodeClick', s, d, n)
        let idInfo = {
          id: d.id,
          upOrg: d.upOrg
        }
        this.$store.commit('setCurrnetNodeInfo', idInfo)
      }
    },
    delNode () {
      let list = this.NODE.parent.data[this.props.children] || this.NODE.parent.data // 节点同级数据
      let _index = 99999 // 要删除的index
      /* if (!n.parent.data.nodes){//删除顶级节点，无children
              list = n.parent.data
            } */
      list.map((c, i) => {
        if (!isNaN(this.DATA.id) && this.DATA.id === c.id) {
          _index = i
        } else if (isNaN(this.DATA.id) && c[this.props.label] === '新增节点') {
          _index = i
        } else {
          // sonar规则校验语法必须else
        }
      })
      list.splice(_index, 1)
    },
    nodeEditFocus (event) {
      if (event.target.className.indexOf('el-icon-circle-check') > -1) {
        if (this.DATA.label === '') {
          this.$message.error('名称不能为空！')
          return false
        }
        if (!/^[a-zA-Z\u4e00-\u9fa5\d]+$/.test(this.DATA.label)) {
          this.$message.error('名称只能由中文、英文、数字组成！')
          return false
        }
        var filer = this.NODE.parent.childNodes.filter(
          o => o.data[this.props.label] === this.DATA.label
        )
        if (
          filer.length > 0
        ) {
          if (this.DATA.label === '新增节点') {
            this.$message.error('请输入名称！')
          } else if (filer[0].id === this.DATA.id) {
            this.$message.error('名称没有修改！')
          } else {
            this.$message.error('名称重复！')
          }
          return
        }
        this.nodeEditPass(this.STORE, this.DATA, this.NODE)
      }
      if (event.target.className.indexOf('el-icon-circle-close') > -1) {
        if (this.DATA[this.props.label] === '新增节点') {
          this.delNode()
        } else {
          this.DATA.label = this.DATA[this.props.label]
        }
        this.chanelNode()
      }
    }
  }
}
</script>

<style>
.icon-success {
  font-size: 16px;
  color: #67c23a;
  cursor: pointer;
}
.icon-success:hover {
  color: #85ce61;
}
.icon-chanel {
  font-size: 16px;
  cursor: pointer;
}
.icon-chanel:hover {
  color: #a6a9ad;
}
.tree-expand {
  width: 100%;
  overflow: visible;
}
.tree-expand .tree-label.tree-new {
  font-weight: 1.4rem;
  color: #333333;
}
.tree-expand .tree-label {
  font-size: 1.2rem;
}
.tree-expand .tree-label .edit {
  height: auto;
  width: 15rem;
}
.tree-expand .tree-btn {
  display: none;
  margin-right: 1.6rem;
}
.tree-expand .tree-btn i {
  color: #8492a6;
  font-size: 0.9em;
  margin-left: 1rem;
}
.node-num {
  color: #a8a8a8;
  font-size: 1.2rem;
  margin-left: 1rem;
}
.anti-white-node-num {
  color: #ffffff;
  font-size: 1.2rem;
  margin-left: 1rem;
}
.tree-label {
  color: #606266;
  font-size: 1.4rem;
}
.anti-white-tree-label {
  color: #ffffff;
  font-size: 1.4rem;
}
.anti-white-el-icon-plus:before {
  color: white;
}
.anti-white-el-icon-edit:before {
  color: white;
}
.anti-white-el-icon-delete:before {
  color: white;
}
.el-tree-node .is-focusable {
  padding-top: 3px;
  padding-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/tree/tree_render.vue